import { apiClient } from './client';
import { 
  MercadoPagoCredentialsResponse, 
  MercadoPagoOAuthStartResponse
} from './types/mercadopago';

/**
 * MercadoPago OAuth API service
 */
export const mercadoPagoApi = {
  /**
   * Check MercadoPago OAuth connection status
   * @returns Promise with connection status
   */
  checkCredentials: async (): Promise<MercadoPagoCredentialsResponse> => {
    return apiClient.get<MercadoPagoCredentialsResponse>('/payment/oauth/mercadopago/credentials/');
  },

  /**
   * Start MercadoPago OAuth flow and get authorization URL
   * @returns Promise with authorization URL and state
   */
  startOAuth: async (): Promise<MercadoPagoOAuthStartResponse> => {
    return apiClient.post<MercadoPagoOAuthStartResponse>('/payment/oauth/mercadopago/start/', {});
  },

  /**
   * Delete/disconnect MercadoPago OAuth credentials
   * @returns Promise with deletion response
   */
  deleteCredentials: async (): Promise<{ message: string }> => {
    return apiClient.delete<{ message: string }>('/payment/oauth/mercadopago/credentials/');
  },
};
